import { forwardRef, useRef } from "react"
import classNames from "classnames"
import { Question } from "components/Question/Question"
import { QuestionInput } from "components/QuestionInput/QuestionInput";
import { QuestionMedia } from "components/QuestionMedia/QuestionMedia";
import { useIsMobileDevice, useScrollDown } from "utils/hooks";
import { FaArrowCircleDown } from "react-icons/fa";

/**
 * This component returns the quiz body for mcq with image as options.
 */
const MCQWithImages = ({
    question,
    type,
    media,
    options,
    optionSubmitHandler,
    mediaLoadHandler,
    isOptionTextLong,
    isQuesMCQWithImageOptions,
    time,
    randomizeOptions
}, ref) => {
    const quesInputContainer = useRef(null)
    const { isScrollDownOptionsBtnVisible, handleScrollDownOptions } = useScrollDown({ overflowElement: quesInputContainer?.current, showBtn: !!options })
    const isMobile = useIsMobileDevice()

    return (
        <div
            className={classNames(
                "flex flex-col justify-between px-[18px] pb-[26px] pt-4",
                "sm:flex sm:flex-col sm:items-center sm:h-[calc(100%-140px)] sm:mt-14",
                "short:h-[calc(100%-112px)] short:sm:mt-7"
            )}
            ref={ref}
        >
            <div className="flex flex-col items-start sm:w-2/3 sm:flex-1 sm:h-[100px] sm:overflow-y-auto">
                <div className="order-2 sm:order-1 sm:mb-5">
                    <Question text={question} type={type} noMedia={!media?.length} />
                </div>
                <div className="h-1/2 order-1 sm:order-2">
                    <QuestionMedia
                        media={media}
                        onMediaLoad={mediaLoadHandler}
                        isQuesMCQWithImageOptions={isQuesMCQWithImageOptions}
                    />
                </div>
            </div>
            <div
                ref={quesInputContainer}
                className={classNames("sm:w-2/3 sm:flex-1 sm:overflow-y-auto")}
            >
                <QuestionInput
                    type={type}
                    showGridView={true}
                    options={options}
                    isOptionTextLong={isOptionTextLong}
                    onSubmit={optionSubmitHandler}
                    isQuesMCQWithImageOptions={isQuesMCQWithImageOptions}
                    time={time}
                    randomizeOptions={randomizeOptions}
                />
                {
                    isScrollDownOptionsBtnVisible && !isMobile
                        ? <div className="w-full flex justify-end fixed right-10 bottom-10 p-2">
                            <button onClick={handleScrollDownOptions} className="bounce-anim bg-transparent cursor-pointer">
                                <FaArrowCircleDown className="w-[30px] h-[30px]" fill={"#2e1500"} />
                            </button>
                        </div> : <></>
                }
            </div>
        </div>
    )
}

export default forwardRef(MCQWithImages)